import { ArrowForward, Cancel } from '@mui/icons-material';
import { Box, Button, Paper, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useBeforeUnload } from 'react-use';
import { PageHeader } from '../../../../components/PageHeader';
import { useClaimsUploadProcessController } from '../../../../hooks/useClaimsUploadProcessController';
import { useXmlDataStore } from '../../../../hooks/useXmlDataStore';
import { PageContent, PageLayout } from '../../../../layout';
import { ScenarioInfoBox } from '../../../../modules/scenarios/ScenarioDetailOverview';
import { XmlSummaryCards } from '../../xml/xml-summary/modules/XmlSummaryCards';

const TRANS_NS = 'claims-upload';

export const ClaimsSummaryPage = () => {
  const { t } = useTranslation(TRANS_NS);
  const { xmlDataModel } = useXmlDataStore();
  const { updateProcess } = useClaimsUploadProcessController();

  // ask user to confirm before leaving page since the data are not saved
  useBeforeUnload(
    true,
    'Opuštěním stránky přijdete o data v paměti a proces nahrání pohledávek budete muset začít znovu.',
  );

  return (
    <PageLayout>
      <PageHeader title={t('title')} subtitle={t('summary.title')} backRouteTo={'/upload'} />
      <PageContent
        sx={{
          flexDirection: 'row',
          flexWrap: 'wrap',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          gap: { md: 4, xs: 2 },
        }}
      >
        <Paper sx={{ width: '100%', p: 2, borderColor: 'primary.main' }}>
          <Typography variant={'subtitle1'}>{t('summary.info', { count: xmlDataModel.noInvoices })}</Typography>
        </Paper>
        <Box flex={1} flexBasis={375}>
          <Typography variant={'h3'} mb={2}>
            {t('summary.claims')}
          </Typography>
          <XmlSummaryCards xmlData={xmlDataModel} transNs={TRANS_NS} />
        </Box>
        <Box flex={1} flexBasis={375}>
          <Typography variant={'h3'} mb={2}>
            {t('summary.scenario')}
          </Typography>
          <ScenarioInfoBox scenarioId={xmlDataModel.scenarioId} />
          <Box display={'flex'} width={'100%'} justifyContent={'center'} mt={2}>
            <Typography variant={'caption'} textAlign={'center'}>
              <Trans
                t={t}
                i18nKey={'summary.scenarioSupport'}
                components={{
                  link1: <Typography fontSize={'inherit'} component={Link} to={'/support'} />,
                }}
              />
            </Typography>
          </Box>
        </Box>
        <Box display={'flex'} width={'100%'} justifyContent={'space-between'}>
          <Button
            component={Link}
            to={'/upload'}
            size={'large'}
            variant={'outlined'}
            startIcon={<Cancel />}
            color={'error'}
          >
            {t('cancel')}
          </Button>
          <Button size={'large'} variant={'contained'} onClick={updateProcess} endIcon={<ArrowForward />}>
            {t('continue')}
          </Button>
        </Box>
      </PageContent>
    </PageLayout>
  );
};
